import React from 'react';

// Minimal zoom placeholder: render nothing (we don't want text/percentage in toolbar)
const Zoom = () => null;

export default Zoom;
